// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__qCVSB","scale":"Text_scale__d1aPN"};